import { jsx as t } from "react/jsx-runtime";
import * as h from "react";
import { Switch as c } from "radix-ui";
const m = "_switchRoot_btcui_1", r = "_switchThumb_btcui_55", o = {
  switchRoot: m,
  switchThumb: r
}, w = h.forwardRef((s, i) => /* @__PURE__ */ t(c.Root, { ref: i, className: o.switchRoot, ...s, children: /* @__PURE__ */ t(c.Thumb, { className: o.switchThumb }) }));
w.displayName = "Switch";
export {
  w as Switch
};
